import type { ExtendedAddressInputKey } from './address-input';
import {
    PostalCodeType,
    LocalityType,
    AdministrativeAreaType,
    DependentLocalityType,
} from '../generated/types';

type AddressInputKeyMessages = Record<ExtendedAddressInputKey, string>;

type LocaleMessages = {
    addressInputKeys: AddressInputKeyMessages;
    postalCodeType: Record<PostalCodeType, string>;
    localityType: Record<LocalityType, string>;
    administrativeAreaType: Record<AdministrativeAreaType, string>;
    dependentLocalityType: Record<DependentLocalityType, string>;
};

export default {
    nl: {
        addressInputKeys: {
            organization: 'Organisatie',
            givenName: 'Voornaam',
            familyName: 'Achternaam',
            additionalName: 'Extra naam',
            addressLine1: 'Adres regel 1',
            addressLine2: 'Adres regel 2',
            locality: 'Plaats/District/Suburb',
            dependentLocality: 'Buurt',
            administrativeArea: 'Staat/Provincie/Regio',
            postalCode: 'Postcode/Zip/Pin/EIR',
            sortingCode: 'Sorteercode',
            countryCode: 'Land',
        },
        postalCodeType: {
            [PostalCodeType.EIR]: 'EIR',
            [PostalCodeType.PIN]: 'Pin',
            [PostalCodeType.ZIP]: 'Zip-code',
            [PostalCodeType.POSTAL]: 'Postcode',
        },
        localityType: {
            [LocalityType.CITY]: 'Stad',
            [LocalityType.DISTRICT]: 'District',
            [LocalityType.POST_TOWN]: 'Post-plaats',
            [LocalityType.SUBURB]: 'Suburb',
        },
        dependentLocalityType: {
            [DependentLocalityType.DISTRICT]: 'District',
            [DependentLocalityType.NEIGHBORHOOD]: 'Buurt',
            [DependentLocalityType.SUBURB]: 'Suburb',
            [DependentLocalityType.TOWNLAND]: 'Townland',
            [DependentLocalityType.VILLAGE_TOWNSHIP]: 'Gemeenschap',
        },
        administrativeAreaType: {
            [AdministrativeAreaType.AREA]: 'Gebied',
            [AdministrativeAreaType.CANTON]: 'Kanton',
            [AdministrativeAreaType.COUNTY]: 'Graafschap',
            [AdministrativeAreaType.DEPARTMENT]: 'Departement',
            [AdministrativeAreaType.DISTRICT]: 'District',
            [AdministrativeAreaType.DO_SI]: 'Do-Si',
            [AdministrativeAreaType.EMIRATE]: 'Emiraat',
            [AdministrativeAreaType.ISLAND]: 'Eiland',
            [AdministrativeAreaType.OBLAST]: 'Oblast',
            [AdministrativeAreaType.PARISH]: 'Parish',
            [AdministrativeAreaType.PREFECTURE]: 'Prefectuur',
            [AdministrativeAreaType.PROVINCE]: 'Provincie',
            [AdministrativeAreaType.STATE]: 'Staat',
        },
    },
    en: {
        addressInputKeys: {
            organization: 'Organisation',
            givenName: 'Given name',
            familyName: 'Family name',
            additionalName: 'Additional name',
            addressLine1: 'Address line 1',
            addressLine2: 'Address line 2',
            locality: 'Plaats/District/Suburb',
            dependentLocality: 'Buurt',
            administrativeArea: 'Administrative area',
            postalCode: 'Postal code',
            sortingCode: 'Sorting code',
            countryCode: 'Country code',
        },
        postalCodeType: {
            [PostalCodeType.EIR]: 'EIR',
            [PostalCodeType.PIN]: 'Pin',
            [PostalCodeType.ZIP]: 'Zip-code',
            [PostalCodeType.POSTAL]: 'Postal',
        },
        localityType: {
            [LocalityType.CITY]: 'City',
            [LocalityType.DISTRICT]: 'District',
            [LocalityType.POST_TOWN]: 'Post town',
            [LocalityType.SUBURB]: 'Suburb',
        },
        dependentLocalityType: {
            [DependentLocalityType.DISTRICT]: 'District',
            [DependentLocalityType.NEIGHBORHOOD]: 'Neighborhood',
            [DependentLocalityType.SUBURB]: 'Suburb',
            [DependentLocalityType.TOWNLAND]: 'Townland',
            [DependentLocalityType.VILLAGE_TOWNSHIP]: 'Village Township',
        },
        administrativeAreaType: {
            [AdministrativeAreaType.AREA]: 'Area',
            [AdministrativeAreaType.CANTON]: 'Canton',
            [AdministrativeAreaType.COUNTY]: 'County',
            [AdministrativeAreaType.DEPARTMENT]: 'Department',
            [AdministrativeAreaType.DISTRICT]: 'District',
            [AdministrativeAreaType.DO_SI]: 'Do-Si',
            [AdministrativeAreaType.EMIRATE]: 'Emirate',
            [AdministrativeAreaType.ISLAND]: 'Island',
            [AdministrativeAreaType.OBLAST]: 'Oblast',
            [AdministrativeAreaType.PARISH]: 'Parish',
            [AdministrativeAreaType.PREFECTURE]: 'Prefecture',
            [AdministrativeAreaType.PROVINCE]: 'Province',
            [AdministrativeAreaType.STATE]: 'State',
        },
    },
} satisfies Record<string, LocaleMessages>;
